const FixScreenWidth = 1440;
const TightsNormalWidth = 1200;
export const getMagicBannerSize = (width, aspectRatio) => {
    return {
        gridWidth: `${width}px`,
        gridHeight: `${aspectRatio * width}px`,
    };
};
export const getSize = (banner) => {
    const { width = "", height = "" } = banner;
    const aspectRatio = width ? +(+height / +width).toFixed(3) : 0;
    return getMagicBannerSize(+width < FixScreenWidth ? TightsNormalWidth : +width, aspectRatio);
};
